import { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../common/header";
import Sidebar from "../common/sidebar";
import Breadcrumb from "../common/menuGuide";
import { getTokenAsync } from "../../utils/tokenManage";
import { formatDate, formatPhone } from "../../utils/dateManage";
import SearchFilter from "../common/searchFilter";
import Pagination from "../common/pagination";
import alertUtils from "../../utils/utils";

function HistoryPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = window.location.pathname;

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isRestoring, setIsRestoring] = useState(false);

    const [consultResultOptions] = useState([
        { value: "", label: "전체" },
        { value: "C", label: "상담완료" },
        { value: "T", label: "업무이관" }
    ]);

    const [keywordOptions] = useState([
        { value: "customerName", label: "고객명" },
        { value: "category", label: "유형" },
        { value: "telNo", label: "연락처" },
        { value: "roomNo", label: "객실호수" },
        { value: "Q", label: "문의내용" },
        { value: "A", label: "답변내용" },
        { value: "M", label: "메모" }
    ]);

    const [sortOptions] = useState([
        // { value: "serviceGroupName", label: "호텔명" },
        { value: "registDate", label: "접수일시" },
        { value: "cnslChannelName", label: "채널" },
        { value: "cnslTypeName", label: "유형" },
        { value: "cnslResult", label: "상담결과" },
        { value: "inquiry", label: "문의내용" },
        { value: "answer", label: "답변내용" },
        { value: "memo", label: "메모" },
    ]);

    const [directionOptions] = useState([
        { value: "asc", label: "오름차순" },
        { value: "desc", label: "내림차순" },
    ]);

    const [serviceGroup, setServiceGroup] = useState("");
    const [consultResult, setConsultResult] = useState("");
    const [keyword, setKeyword] = useState("customerName");
    const [keywordText, setKeywordText] = useState("");
    const [sortBy, setSortBy] = useState("registDate");
    const [direction, setDirection] = useState("desc");

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);

    const size = 10;
    const totalPages = Math.ceil(total / size);

    const scrollRef = useRef(null);
    const [isEnd, setIsEnd] = useState(false);

    const closeSidebar = () => {
        setSidebarOpen(false);
    };

    const handleBreadcrumbClick = (item, index) => {
        if (index === 0) {
            setSidebarOpen(true);
        }
    };

    const mapCnslResult = (value) => {
        if (value === "C") return "상담완료";
        if (value === "T") return "업무이관";
        return value || "";
    };

    const getCustCode = async (selectedServiceGroup) => {
        if (!selectedServiceGroup || selectedServiceGroup === "ALL") {
            return "";
        }

        try {
            const authToken = await getTokenAsync();

            const res = await fetch(
                `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/app/category/custCode/${selectedServiceGroup}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": authToken
                    }
                }
            );

            console.log(res);
            if (!res.ok) {
                throw new Error("custCode 조회 실패");
            }

            const data = await res.json();
            return data || "";
        } catch (e) {
            console.error(e);
            return "";
        }
    };

    const restoreSearchCondition = () => {
        try {
            const saved = sessionStorage.getItem("historySearchCondition");
            if (!saved) return null;

            const parsed = JSON.parse(saved);

            return {
                page: parsed.page ?? 0,
                serviceGroup: parsed.serviceGroup || "",
                consultResult: parsed.cnlsResult || "",
                keyword: parsed.keyword || "customerName",
                keywordText: parsed.keywordText || "",
                sortBy: parsed.sortBy || "",
                direction: parsed.direction || "",
                startDate: parsed.startDate ? new Date(parsed.startDate) : new Date(),
                endDate: parsed.endDate ? new Date(parsed.endDate) : new Date()
            };
        } catch (e) {
            console.error("검색조건 복원 실패", e);
            return null;
        }
    };

    const saveSearchCondition = (params) => {
        sessionStorage.setItem(
            "historySearchCondition",
            JSON.stringify({
                page: params.page,
                size: params.size,
                custCode: params.custCode,
                serviceGroup: params.serviceGroup,
                cnlsResult: params.cnlsResult,
                keyword: params.keyword,
                keywordText: params.keywordText,
                sortBy: params.sortBy,
                direction: params.direction,
                startDate: params.startDate,
                endDate: params.endDate
            })
        );
    };

    const getHistory = async ({
                                       page: nextPage = 0,
                                       serviceGroup: nextServiceGroup = serviceGroup,
                                       cnlsResult = consultResult,
                                       keyword: nextKeyword = keyword,
                                       keywordText: nextKeywordText = keywordText,
                                       sortBy: nextSortBy = sortBy,
                                       direction: nextDirection = direction,
                                       startDate: nextStartDate = startDate,
                                       endDate: nextEndDate = endDate
                                   }) => {
        try {
            const authToken = await getTokenAsync();

            if (!authToken) {
                return;
            }

            const currentCustCode =
                nextServiceGroup && nextServiceGroup !== "ALL"
                    ? await getCustCode(nextServiceGroup)
                    : "";

            const params = {
                page: nextPage + 1, // 1부터 시작
                size,
                custCode: currentCustCode,
                serviceGroup: nextServiceGroup,
                cnlsResult,
                keyword: nextKeyword,
                keywordText: nextKeywordText,
                sortBy: nextSortBy,
                direction: nextDirection,
                startDate: formatDate(nextStartDate),
                endDate: formatDate(nextEndDate)
            };

            saveSearchCondition({
                page: nextPage, // 프론트 내부는 0-based로 저장
                size,
                custCode: currentCustCode,
                serviceGroup: nextServiceGroup,
                cnlsResult,
                keyword: nextKeyword,
                keywordText: nextKeywordText,
                sortBy: nextSortBy,
                direction: nextDirection,
                startDate: formatDate(nextStartDate),
                endDate: formatDate(nextEndDate)
            });

            const res = await fetch(
                `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/app/counseling/list`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": authToken
                    },
                    body: JSON.stringify(params)
                }
            );

            if (res.status === 401) {
                await alertUtils.warningWithCallback(
                    "로그인이 만료 되었습니다.",
                    () => {
                        window.location.href = "/";
                    }
                );

                return null;
            }

            if (!res.ok) {
                throw new Error("상담 이력 조회 실패");
            }

            const data = await res.json();

            setList(data.data || []);
            setTotal(data.total || 0);
            setPage(nextPage);
        } catch (e) {
            console.error(e);

            if (e.message === "Unauthorized") {
                return;
            }

            alertUtils.error("조회 실패");
        }
    };

    useEffect(() => {
        if (!location.state?.restore) return;

        const savedCondition = restoreSearchCondition();
        if (!savedCondition) return;

        setIsRestoring(true);
        setServiceGroup(savedCondition.serviceGroup || "");
        setConsultResult(savedCondition.consultResult || "");
        setKeyword(savedCondition.keyword || "customerName");
        setKeywordText(savedCondition.keywordText || "");
        setSortBy(savedCondition.sortBy);
        setDirection(savedCondition.direction);
        setStartDate(savedCondition.startDate);
        setEndDate(savedCondition.endDate);
        setPage(savedCondition.page ?? 0);
    }, [location.state]);

    useEffect(() => {
        const savedCondition = restoreSearchCondition();
        if (!savedCondition) return;

        setIsRestoring(true);
        setServiceGroup(savedCondition.serviceGroup || "");
        setConsultResult(savedCondition.consultResult || "");
        setKeyword(savedCondition.keyword || "customerName");
        setKeywordText(savedCondition.keywordText || "");
        setSortBy(savedCondition.sortBy);
        setDirection(savedCondition.direction);
        setStartDate(savedCondition.startDate);
        setEndDate(savedCondition.endDate);
        setPage(savedCondition.page ?? 0);
    }, []);

    useEffect(() => {
        if (!serviceGroup) return;

        if (isRestoring) {
            const savedCondition = restoreSearchCondition();

            if (savedCondition) {
                getHistory({
                    page: savedCondition.page ?? 0,
                    serviceGroup: savedCondition.serviceGroup || serviceGroup,
                    cnlsResult: savedCondition.consultResult || "",
                    keyword: savedCondition.keyword || "customerName",
                    keywordText: savedCondition.keywordText || "",
                    sortBy: savedCondition.sortBy || "registDate",
                    direction: savedCondition.direction || "desc",
                    startDate: savedCondition.startDate,
                    endDate: savedCondition.endDate
                });
            }

            setIsRestoring(false);
            navigate(location.pathname, { replace: true });
            return;
        }

        getHistory({
            page: 0,
            serviceGroup,
            cnlsResult: consultResult,
            keyword,
            keywordText,
            sortBy,
            direction,
            startDate,
            endDate
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serviceGroup, isRestoring]);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const handleScroll = () => {
            const isScrollEnd =
                el.scrollLeft + el.clientWidth >= el.scrollWidth - 10;
            setIsEnd(isScrollEnd);
        };

        el.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => el.removeEventListener("scroll", handleScroll);
    }, []);

    const handleSearch = () => {
        getHistory({
            page: 0,
            serviceGroup,
            cnlsResult: consultResult,
            keyword,
            keywordText,
            sortBy,
            direction,
            startDate,
            endDate
        });
    };

    const handleRowClick = (row) => {
        sessionStorage.setItem("historyDetailData", JSON.stringify(row));
        navigate("/historyDetail");
    };

    return (
        <div className="container">
            <Header
                isSidebarOpen={sidebarOpen}
                onMenuToggle={() => setSidebarOpen((prev) => !prev)}
                onServiceGroupChange={setServiceGroup}
            />

            {sidebarOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            <Sidebar
                isOpen={sidebarOpen}
                onClose={closeSidebar}
                currentPath={currentPath}
            />

            <main className="content">
                <Breadcrumb items={["상담 관리", "상담이력조회"]}
                            onItemClick={handleBreadcrumbClick}
                />

                <section className="page">
                    <h1>상담 이력 조회</h1>

                    <div className="filters">
                        <SearchFilter
                            key={serviceGroup}
                            serviceGroup={serviceGroup}
                            startDate={startDate}
                            endDate={endDate}
                            onServiceGroupChange={setServiceGroup}
                            onStartDateChange={setStartDate}
                            onEndDateChange={setEndDate}
                            onSortByChange={setSortBy}
                            onDirectionChange={setDirection}
                        />

                        <div className="filter-row">
                            <div className="filter-label">상담결과</div>

                            <div className="filter-field">
                                <select
                                    className="form-select"
                                    value={consultResult}
                                    onChange={(e) => setConsultResult(e.target.value)}
                                >
                                    {consultResultOptions.map((item) => (
                                        <option key={item.value} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="filter-label">검색조건</div>

                            <div className="filter-write">
                                <div className="filter-field">
                                    <select
                                        className="form-select"
                                        value={keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                    >
                                        {keywordOptions.map((item) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </select>

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="검색어를 입력하세요"
                                        value={keywordText}
                                        onChange={(e) => setKeywordText(e.target.value)}
                                        onKeyUp={(e) => {
                                            if (e.key === "Enter") {
                                                handleSearch();
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="filter-label">정렬기준</div>

                            <div className="filter-write">
                                <div className="filter-field">
                                    <select
                                        className="form-select"
                                        value={sortBy}
                                        onChange={(e) => setSortBy(e.target.value)}
                                    >
                                        {sortOptions.map((item) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </select>

                                    <select
                                        className="form-select"
                                        value={direction}
                                        onChange={(e) => setDirection(e.target.value)}
                                    >
                                        {directionOptions.map((item) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            </div>
                        </div>

                        <div className="filter-row filter-submit">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSearch}
                            >
                                조회
                            </button>
                        </div>
                    </div>


                    <div className="section-header">
                        <h2>
                            상담 이력 목록 (총 <span>{total}</span>건)
                        </h2>
                    </div>

                    <div className={`table-scroll-hint ${isEnd ? "hide-hint" : ""}`}>
                        <div className="table-wrap counsel-list scroll-container" ref={scrollRef}>
                            <table className="table-fixed">
                                <colgroup>
                                    <col style={{width: "150px"}}/>
                                    <col style={{width: "120px"}}/>
                                    <col style={{width: "100px"}}/>
                                    <col style={{width: "100px"}}/>
                                    <col style={{width: "100px"}}/>
                                    <col style={{width: "120px"}}/>
                                    <col style={{width: "80px"}}/>
                                    <col style={{width: "100px"}}/>
                                    <col style={{width: "180px"}}/>
                                    <col style={{width: "180px"}}/>
                                    <col style={{width: "180px"}}/>
                                </colgroup>

                                <thead>
                                <tr>
                                    <th>호텔명</th>
                                    <th>접수일시</th>
                                    <th>채널</th>
                                    <th>유형</th>
                                    <th>고객명</th>
                                    <th>연락처</th>
                                    <th>객실호수</th>
                                    <th>상담결과</th>
                                    <th>문의내용</th>
                                    <th>답변내용</th>
                                    <th>메모</th>
                                </tr>
                                </thead>

                                <tbody>
                                {list.length === 0 ? (
                                    <tr>
                                        <td colSpan={11}>조회된 데이터가 없습니다.</td>
                                    </tr>
                                ) : (
                                    list.map((row, idx) => (
                                        <tr
                                            key={idx}
                                            className="clickable-row"
                                            onClick={() => handleRowClick(row)}
                                        >
                                            <td>{row.serviceGroupName || ""}</td>
                                            <td>{row.registDate || ""}</td>
                                            <td>{row.cnslChannelName || ""}</td>
                                            <td>{row.cnslTypeName || ""}</td>
                                            <td className="text-truncate">
                                                <span className="cell-block-td">
                                                    {row.customerName || ""}
                                                </span>
                                            </td>
                                            <td>{formatPhone(row.customerTelNo)}</td>
                                            <td>{row.etc1 || ""}</td>
                                            <td>{mapCnslResult(row.cnslResult)}</td>
                                            <td className="text-truncate">
                                                <span className="cell-block-td">
                                                    {row.inquiry || ""}
                                                </span>
                                            </td>
                                            <td className="text-truncate">
                                                <span className="cell-block-td">
                                                    {row.answer || ""}
                                                </span>
                                            </td>
                                            <td className="text-truncate">
                                                <span className="cell-block-td">
                                                    {row.memo || ""}
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        </div>
                        {!isEnd && <div className="scroll-arrow-hint"></div>}
                    </div>

                    <Pagination
                        page={page}
                            totalPages={totalPages}
                            onPageChange={(nextPage) =>
                                getHistory({
                                    page: nextPage,
                                    startDate,
                                    endDate,
                                    serviceGroup,
                                    cnlsResult: consultResult,
                                    keyword,
                                    keywordText
                                })
                            }
                        />
                </section>
            </main>
        </div>
    );
}

export default HistoryPage;